module.exports = __webpack_public_path__ + "img/twelve-o'clock.f9e79f97.png";